import React, { useEffect, useContext } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Color_Delete from '../../Assets/Icons/Icon_Color_Delete.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';

export default function Subwindow_MapEditor_RippleDelete({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Confirmer_Respond } = useStatus();
    const { Map_Information_Type } = useMapRenderer();
    const Confirm = () => {
        Confirmer_Respond(true, {}, true, "Window_MapEditor_RippleDelete");
        // UI.Subwindows_Close('Window_MapEditor_RippleDelete');
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_MapEditor_RippleDelete");
    }

    useEffect(() => {
        const el = document.getElementById("Window_MapEditor_RippleDelete");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    return (
        <ui-subwindow Type='Modal' id='Window_MapEditor_RippleDelete' State='Inactive' Visibility='Close'>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' onClick={Cancel}/>
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Color_Delete} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Remove
                    {Map_Information_Type == "Building" ? " building"
                        : Map_Information_Type == "Floor" ? " floor"
                            : " room"}
                    ?
                </h2>

                <p className='General_Paragraph' style={{ textAlign: "center" }}>
                    {Map_Information_Type == "Building" ? "Rooms and floors under it will also be removed."
                        : Map_Information_Type == "Floor" ? "Rooms under it will also be removed." : ""}
                </p>
                <p className='General_Paragraph' style={{ marginBottom: "20px", textAlign: "center" }}>
                    Removed items can still be restored from the bin.
                </p>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State='Negative' onClick={Confirm}>
                    Remove 
                    {Map_Information_Type == "Building" ? " building"
                        : Map_Information_Type == "Floor" ? " floor"
                            : " room"}
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
